var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({staticClass:"menu-module-footer"},'div',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.$t('enterprise.see-more')))]),_c('m-svg-icon',{staticClass:"menu-module-footer-icon",attrs:{"name":"jiantou1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }